import { Component, OnInit } from '@angular/core';
import { GlobalserviceService } from './../globalservice.service';

@Component({
  selector: 'app-qrcode',
  templateUrl: './qrcode.component.html',
  styleUrls: ['./qrcode.component.css'],
  inputs: ['qrdata']
})
export class QrcodeComponent implements OnInit {
  user; EMP_ID; qr_url;mydata;
  constructor(
    public globalservice: GlobalserviceService,
  ) { }


  ngOnInit() {
    this.EMP_ID = localStorage.getItem('EMP_ID');
    this.qr_url = localStorage.getItem('qr_url');
  }

  reloadqrcode() {
    alert();
    this.mydata={"EMP_ID":this.EMP_ID};
    this.globalservice.qrdata(this.mydata).subscribe(data => {
      debugger;
      localStorage.setItem('EMP_ID', this.mydata);
      localStorage.setItem('qr_url', this.globalservice.base_url + data['Data1']);
      console.log(localStorage); debugger;
    }, err => {
      alert("Error Occured");
    });
  }


}
